import styled from 'styled-components'

export const TableContainer = styled.div`
	background: white;
	border-radius: 12px;
	border: 1px solid ${props => props.theme.colors.greys.dividerGray};
	overflow: hidden;
`

export const GridTable = styled.div`
	width: 100%;
	overflow: auto;
	height: 100%;
	min-height: 370px;
	display: flex;
	flex-direction: column;
`

export const EmptyStateContainer = styled.div`
	flex: 1;
	min-height: 0;
	display: flex;
	align-items: center;
	justify-content: center;
`

export const GridHeader = styled.div`
	display: grid;
	width: 100%;
	background-color: ${props => props.theme.colors.greys.lightGrey};
	border-bottom: 1px solid ${props => props.theme.colors.greys.dividerGray};
	grid-template-columns: ${({ $gridTemplateColumns }) => $gridTemplateColumns};
`

export const GridHeaderCell = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 8px;
	justify-content: flex-start;
	text-align: left;
	padding: 16px 20px;
	font-size: 14px;
	font-weight: 600;
	color: ${props => props.theme.colors.text.prymaryText};
`

export const GridRow = styled.div`
	display: grid;
	width: 100%;
	border-bottom: 1px solid #f0f0f0;
	grid-template-columns: ${({ $gridTemplateColumns }) => $gridTemplateColumns};
	&:last-child {
		border-bottom: none;
	}
`

export const GridCell = styled.div`
	padding: 16px 20px;
	font-size: 14px;
	color: #1a1a1a;
	min-width: 0;
`

export const DownloadLinkContainer = styled.a`
	display: flex;
	flex-direction: row;
	gap: 12px;
	align-items: center;
`

export const DownloadLink = styled.a`
	color: ${props => props.color || props.theme.colors.brand.blueOmint};
	text-decoration: underline;
	font-weight: 500;
	display: inline-flex;
	align-items: center;
	gap: 4px;
`
